import React, { useState, useEffect, useRef } from "react";
import {
  checkEnvelopeCredit,
  checkEnvelopeStorage,
  getEnvelopeSenderList,
} from "../../../../services/CommonService";
import { useNavigate } from "react-router-dom";
import Utils from "../../../../utils";
import Pagination from "react-js-pagination";
import DeleteEnvelope from "./DeleteEnvelope";
import TransferEnvelope from "./TransferEnvelope";
import CopyEnvelope from "./CopyEnvelope";
import { toast } from "react-toastify";
import CheckEnvelopeCredit from "./CheckEnvelopeCredit";
import CheckEnvelopeStorage from "./CheckEnvelopeStorage";
import useDocumentCounts from "./useDocumentCounts";
import "./envelopeTabs.css";
import FilterBar from "./components/FilterBar"; 
const lengths = Utils.tableShowLengths();

const highlightText = (text, search) => {
  if (!search) return text;
  const regex = new RegExp(`(${search})`, "gi");
  const parts = text.split(regex);
  return parts.map((part, i) =>
    regex.test(part) ? <mark key={i}>{part}</mark> : part
  );
};

function ManageEnvelope() {
  const navigate = useNavigate();
  const userData = Utils.loginUserData();
  const userEmail = userData?.email || "";

  const [senderList, setSenderList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [totalData, setTotalData] = useState(0);
  
  const [dataParams, setDataParams] = useState({
    limit: lengths[0],
    page: 1,
    status_id: 1,
    search: "",
    sender_id: "",
    order_column: "created_at",
    order_by: false,
    is_effect: false,
  });

  const [deleteEnvelope, setDeleteEnvelope] = useState({ id: 0, name: "" });
  const [copyEnvelope, setCopyEnvelope] = useState(0);
  const [expandedEnvelopes, setExpandedEnvelopes] = useState({});

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("In Progress");
  const dropdownRef = useRef(null);

  const openCheckEnvelopeRef = useRef(null);
  const openCheckEnvelopeStorageRef = useRef(null);

  const {
    counts: { totalFiles, totalInProgress, totalDraft, totalCompleted },
    envelopeList,
    envelopeProcess,
    loading,
    setLoading,
  } = useDocumentCounts({
    userEmail,
    selectedUserId,
    dataParams,
    userId: selectedUserId,
  });

  useEffect(() => {
    setTotalData(totalInProgress);
  }, [totalInProgress]);

  useEffect(() => {
    getEnvelopeSenderList()
      .then((response) => {
        const senderData = response.data.data;
        setSenderList(senderData);
        if (senderData.length > 0) {
          setSelectedUserId(senderData[0].id);
        }
      })
      .catch((err) => {});
  }, []);

  const handleData = (e, type) => {
    let params = { ...dataParams };
    if (type === "pagination") {
      params.page = e;
    } else if (type === "sender") {
      params.sender_id = e.target.value;
      setSelectedUserId(e.target.value);
    } else if (type === "search") {
      params.search = e.target.value;
    } else if (type === "limit") {
      params.limit = parseInt(e.target.value);
    }
    setDataParams(params);
  };

  // const handleSearchKeyDown = (e) => {
  //   if (e.key === 'Enter') {
       
  //       let params = { ...dataParams };
  //       params.search = e.target.value;
  //       setDataParams(params);
  //   }
  // };

  // const onCopyEnvelope = (e, data) => {
  //   e.preventDefault();
  //   setCopyEnvelope(data.id);
  // };

  // const onDeleteEnvelope = (e, data) => {
  //   e.preventDefault();
  //   setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  // };

  const handleManageView = (e, data, recipient) => {
      if (parseInt(data.is_credit) === 0) {
        setLoading(true);
        checkEnvelopeCredit({})
          .then((response) => {
            setLoading(false);
            if (response.data.is_credit === true) {
              navigate("/manage/" + data.uuid, {
                state: {
                  recipient_id: recipient.id,
                  recipient_name:
                    recipient.first_name + " " + recipient.last_name,
                },
              });
            } else {
              openCheckEnvelopeRef?.current.click();
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error(Utils.getErrorMessage(err));
          });
      } else if (parseInt(data.is_storage_full) === 1) {
        setLoading(true);
        checkEnvelopeStorage({ envelope_id: data.id })
          .then((response) => {
            setLoading(false);
            if (response.data.is_storage_full === false) {
              navigate("/manage/" + data.uuid, {
                state: {
                  recipient_id: recipient.id,
                  recipient_name:
                    recipient.first_name + " " + recipient.last_name,
                },
              });
            } else {
              openCheckEnvelopeStorageRef?.current.click();
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error(Utils.getErrorMessage(err));
          });
      } else {
        navigate("/manage/" + data.uuid, {
          state: {
            recipient_id: recipient.id,
            recipient_name: recipient.first_name + " " + recipient.last_name,
          },
        });
      }
  };
  
  const handleManageMessageView = (e, data, recipient, type) => {
      if (parseInt(data.is_credit) === 0) {
        setLoading(true);
        checkEnvelopeCredit({})
          .then((response) => {
            setLoading(false);
            if (response.data.is_credit === true) {
              navigate("/manage/" + data.uuid + "/" + type, {
                state: {
                  recipient_id: recipient.id,
                  recipient_name:
                    recipient.first_name + " " + recipient.last_name,
                },
              });
            } else {
              openCheckEnvelopeRef?.current.click();
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error(Utils.getErrorMessage(err));
          });
      } else if (parseInt(data.is_storage_full) === 1) {
        setLoading(true);
        checkEnvelopeStorage({ envelope_id: data.id })
          .then((response) => {
            setLoading(false);
            if (response.data.is_storage_full === false) {
              navigate("/manage/" + data.uuid + "/" + type, {
                state: {
                  recipient_id: recipient.id,
                  recipient_name:
                    recipient.first_name + " " + recipient.last_name,
                },
              });
            } else {
              openCheckEnvelopeStorageRef?.current.click();
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error(Utils.getErrorMessage(err));
          });
      } else {
        navigate("/manage/" + data.uuid + "/" + type, {
          state: {
            recipient_id: recipient.id,
            recipient_name: recipient.first_name + " " + recipient.last_name,
          },
        });
      }
  };


  const toggleExpand = (envelopeId) => {
    setExpandedEnvelopes((prev) => ({
      ...prev,
      [envelopeId]: !prev[envelopeId],
    }));
  };

  const dropdownOptions = [
    { label: "In Progress", color: "partial", badge: totalInProgress, route: "/manage" },
    { label: "Draft", color: "unpaid", badge: totalDraft, route: "/manage/draft" },
    { label: "Completed", color: "paid", badge: totalCompleted, route: "/manage/completed" },
    { label: "Contract Files", color: "files", route: "/manage/files" },
  ];

  const handleDropdownOptionClick = (option) => {
    setSelectedOption(option.label);
    setIsDropdownOpen(false);
    navigate(option.route);
  };

  const handleManageNegotiation = () => {
    navigate("/manage/negotiation");
  };

  const handleManageSleeve = () => {
    navigate("/manage");
  };

  const createContract = () => {
    navigate("/client-portal/sleeve");
  };

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}

      <section className="main_wrapper section-bg-color manage_heading h-100">
        <div className="custom_container">
          
          <FilterBar
            searchText={dataParams.search}
            setSearchText={(val) => handleData({ target: { value: val } }, "search")} 
            handleManageSleeve={handleManageSleeve} 
            handleManageNegotiation={handleManageNegotiation}
            createContract={createContract} 
            selectedOption={selectedOption}
            dropdownOptions={dropdownOptions}
            handleDropdownOptionClick={handleDropdownOptionClick}
            tags={[]} 
            activeTab="contract"
          />

          <div className="modern-table-container" id="nav-tabContent">
            <div
              className="table-wrapper"
              id="Inprogress-detail"
              role="tabpanel"
              aria-labelledby="Inprogress"
              style={{ minHeight: "400px" }}
            >
              <table className="modern-table">
                {/* HEADER */}
                <thead>
                  <tr className="bg_blue">
                    <th style={{ width: "240px" }}>
                      Contract Name <i className="bi bi-arrow-down-up ms-1" />
                    </th>
                    <th style={{ width: "140px" }}>Due Date</th>
                    <th style={{ width: "220px" }}>Collaborators</th>
                    <th style={{ width: "120px" }} className="text-center">Awaiting</th>
                    <th style={{ width: "140px" }} className="text-center">Needs Review</th>
                    <th style={{ width: "130px" }} className="text-center">Approved</th>
                    <th style={{ width: "120px" }} className="text-center">Messages</th>
                    <th style={{ width: "130px" }} className="text-center">Manage</th>
                    <th style={{ width: "60px" }} className="text-center">Actions</th>
                  </tr>
                </thead>

                {/* BODY */}
                <tbody>
                  {envelopeList.map((item, index) => {
                    const isExpanded = expandedEnvelopes[item.id] || false;
                    const recipientsToShow = isExpanded
                      ? item.recipient_list
                      : item.recipient_list.slice(0, 1);

                    return recipientsToShow.map((recipient, r) => (
                      <tr key={`${index}-${r}`}>
                        {/* Data Cells (Same as original) */}
                         <td style={{ width: "240px" }}>
                          <div className="fw-bold text-primary cur-pointer">
                            {highlightText(item.envelope_name, dataParams.search)}
                          </div>
                          <div className="text-muted small d-flex flex-column flex-lg-row gap-1 mt-1">
                            <span>{item.created_at}</span>
                            <span>
                              <i className="bi bi-person me-1"></i>
                              {item.sender_name}
                            </span>
                          </div>
                        </td>

                        {r === 0 && (
                          <td style={{ width: "140px" }} rowSpan={recipientsToShow.length}>
                            {item.due_date}
                          </td>
                        )}

                         <td style={{ width: "220px" }}>
                          {recipient.first_name} {recipient.last_name}
                          {item.recipient_list.length > 1 && r === 0 && (
                            <span
                              className="ms-2 text-primary cur-pointer"
                              onClick={() => toggleExpand(item.id)}
                            >
                              {isExpanded ? (
                                <><i className="bi bi-chevron-up"></i> Less</>
                              ) : (
                                <>
                                  <span className="badge bg-primary me-1">
                                    +{item.recipient_list.length - 1}
                                  </span>
                                  <i className="bi bi-chevron-down"></i>
                                </>
                              )}
                            </span>
                          )}
                        </td>
                        
                        <td className="text-center"><span className="needs_review">{recipient.awaiting}</span></td>
                        <td className="text-center"><span className="needs_review bg_light_blue">{recipient.need_review}</span></td>
                        <td className="text-center">
                            <span className="badge bg-light rounded-pill p-3 text-dark border">
                                {recipient.approved}/{recipient.total_envelope}
                            </span>
                        </td>
                        <td className="text-center">
                            <i className="bi bi-chat-fill fs-5 cur-pointer" onClick={(e) => handleManageMessageView(e, item, recipient, "message")}></i>
                        </td>
                         <td className="text-center">
                          <button className="btn btn-primary btn-sm" onClick={(e) => handleManageView(e, item, recipient)}>
                            Manage
                          </button>
                        </td>
                        
                        {r === 0 && (
                          <td style={{ width: "60px" }} className="text-center" rowSpan={recipientsToShow.length}>
                             <div className="dropdown">
                              <button className="justify-content-center align-items-center bg-transparent" type="button" data-bs-toggle="dropdown">
                                <i className="bi bi-three-dots-vertical fs-5"></i>
                              </button>
                              <ul className="dropdown-menu dropdown-menu-end">
                                <li>
                                  <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#CopyEnvelope" onClick={() => setCopyEnvelope(item.id)}>
                                    <i className="bi bi-files me-2"></i> Duplicate
                                  </button>
                                </li>
                                <li>
                                  <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#transferEnvelope" onClick={() => setDeleteEnvelope({ id: item.id, name: item.envelope_name })}>
                                    <i className="bi bi-arrow-left-right me-2"></i> Transfer
                                  </button>
                                </li>
                                <li>
                                  <button className="dropdown-item text-danger" data-bs-toggle="modal" data-bs-target="#DeleteEnvelope" onClick={() => setDeleteEnvelope({ id: item.id, name: item.envelope_name })}>
                                    <i className="bi bi-trash me-2"></i> Delete
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        )}
                      </tr>
                    ));
                  })}
                  
                  {envelopeList.length === 0 && (
                    <tr>
                      <td colSpan={9}>
                        <div className="empty-state-content">
                          <div className="empty-state-icon"><i className="bi bi-inbox"></i></div>
                          <h5 className="empty-state-text">{envelopeProcess || "No contracts found"}</h5>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {totalData > dataParams.limit && (
            <div className="table_footer_wrap mt-4">
               <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <span className="me-2 text-muted">Show</span>
                  <select
                    className="form-select form-select-sm"
                    value={dataParams.limit}
                    style={{ width: "80px" }}
                    onChange={(e) => handleData(e, "limit")}
                  >
                    {lengths && lengths.map((item, i) => <option value={item} key={i}>{item}</option>)}
                  </select>
                  <span className="ms-2 text-muted">entries per page</span>
                </div>
                <div className="pagination-wrapper">
                  <Pagination
                    activePage={dataParams.page}
                    itemsCountPerPage={dataParams.limit}
                    totalItemsCount={totalData}
                    onChange={(e) => handleData(e, "pagination")}
                    pageRangeDisplayed={5}
                    itemClass="page-item"
                    linkClass="page-link"
                    activeClass="active"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        
        <DeleteEnvelope deleteEnvelope={deleteEnvelope} setDeleteEnvelope={setDeleteEnvelope} setLoading={setLoading} dataParams={dataParams} setDataParams={setDataParams} />
        <TransferEnvelope deleteEnvelope={deleteEnvelope} setDeleteEnvelope={setDeleteEnvelope} senderList={senderList} setLoading={setLoading} dataParams={dataParams} setDataParams={setDataParams} />
        <CopyEnvelope copyEnvelope={copyEnvelope} setCopyEnvelope={setCopyEnvelope} setLoading={setLoading} />
      </section>

      <span data-bs-toggle="modal" data-bs-target="#checkEnvelopeCredit" ref={openCheckEnvelopeRef} />
      <span data-bs-toggle="modal" data-bs-target="#checkEnvelopeStorage" ref={openCheckEnvelopeStorageRef} />

      <CheckEnvelopeCredit />
      <CheckEnvelopeStorage />
    </>
  );
}

export default ManageEnvelope;